import Utilities from "./Utility";

function numberOfTrailingZeros(i: number): number {
    // HD, Figure 5-14
    let y: number;
    if (i === 0) return 32;
    let n: number = 31;
    y = i << 16; if (y !== 0) { n = n - 16; i = y; }
    y = i << 8; if (y !== 0) { n = n - 8; i = y; }
    y = i << 4; if (y !== 0) { n = n - 4; i = y; }
    y = i << 2; if (y !== 0) { n = n - 2; i = y; }
    return n - ((i << 1) >> 31);
}

const DIGITS: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
const MASK: number = DIGITS.length - 1;
const SHIFT: number = numberOfTrailingZeros(DIGITS.length);
const CHAR_MAP: Record<string, number>[] = [];
const SEPARATOR: string = "-";

for (let i: number = 0; i < DIGITS.length; i++)
    CHAR_MAP[DIGITS[i]] = i;

class Base32 {

    static Decode(encoded: string): Uint16Array {
        // Remove whitespace and separators
        encoded = encoded.trim().replace(SEPARATOR, "");

        // Remove padding. Note: the padding is used as hint to determine how many
        // bits to decode from the last incomplete chunk (which is commented out
        // below, so this may have been wrong to start with).
        encoded = encoded.replace(/[=]*$/g, "");

        // Canonicalize to all upper case
        encoded = encoded.toUpperCase();
        if (encoded.length === 0) {
            return new Uint16Array(0);
        }

        let encodedLength: number = encoded.length;
        let outLength: number = encodedLength * SHIFT / 8;
        let result: Uint16Array = new Uint16Array(outLength);
        let buffer: number = 0;
        let next: number = 0;
        let bitsLeft: number = 0;

        for (let c of encoded) {
            if (!CHAR_MAP[c])
                throw Utilities.createError("Illegal character: " + c);

            buffer <<= SHIFT;
            buffer |= CHAR_MAP[c] & MASK;
            bitsLeft += SHIFT;
            if (bitsLeft >= 8) {
                result[next++] = (buffer >> (bitsLeft - 8));
                bitsLeft -= 8;
            }
        }
        // We'll ignore leftover bits for now.
        //
        // if (next != outLength || bitsLeft >= SHIFT) {
        //  throw new DecodingException("Bits left: " + bitsLeft);
        // }
        return result;
    }

    static Encode(data: Uint16Array, padOutput: boolean = false): string {
        if (data.length === 0) {
            return "";
        }

        // SHIFT is the number of bits per output character, so the length of the
        // output is the length of the input multiplied by 8/SHIFT, rounded up.
        // The computation below will fail, so don't do it.
        if (data.length >= (1 << 28))
            throw Utilities.createError("Argument out of range!");

        let result: string = "";

        let buffer: number = data[0];
        let next: number = 1;
        let bitsLeft: number = 8;

        while (bitsLeft > 0 || next < data.length) {
            if (bitsLeft < SHIFT) {
                if (next < data.length) {
                    buffer <<= 8;
                    buffer |= (data[next++] & 0xff);
                    bitsLeft += 8;
                } else {
                    let pad: number = SHIFT - bitsLeft;
                    buffer <<= pad;
                    bitsLeft += pad;
                }
            }
            let index: number = MASK & (buffer >> (bitsLeft - SHIFT));
            bitsLeft -= SHIFT;
            result += DIGITS[index];
        }
        if (padOutput) {
            let padding: number = 8 - (result.length % 8);
            for (let i: number = 0; i < (padding === 8 ? 0 : padding); i++)
                result += "=";
        }
        return result.toString();
    }
}

export default Base32;